import React, { useState, useEffect, useRef } from "react";
import { useAuth } from "../../AuthContext";
import Axios from 'axios';
import { useNavigate,useParams } from "react-router-dom";
import { MdLocationOn } from "react-icons/md";
import { FaPlus } from "react-icons/fa6";
import FillerImage from "../../assets/filler-image.jpg";
import Navbar from "../../components/Navbar.js";
import Stars from "../../components/Stars.js"
import DynamicStarRating from "../../components/DynamicStarRating.js";
import { convertBase64, convertURL } from "../../imageHandler";


function AddReview() {
    console.log("Add Review component rendered");
    const { loggedIn, user } = useAuth();
    console.log(user.id)
    const sampleId = useParams().data;

    const navigate = useNavigate();
    const [LogoImage, setLogoImage] = useState(FillerImage);
    const [MainImage,setMainImage] = useState(FillerImage);
    const [BuildingName,setBuildingName] = useState();
    const [CollegeName, setCollegeName] = useState();
    const [BathroomName, setBathroomName] = useState();
    const [BathroomFloor, setBathroomFloor] = useState();
    const [BathroomAddress, setBathroomAddress] = useState();
    const [BathroomRating, setBathroomRating] = useState(0);
    const [BathroomReviewCount, setBathroomReviewCount] = useState(0);
    const [BathroomQualities, setBathroomQualities] = useState([])
    // const [dynamicBathroomQualities, setDynamicBathroomQualities] = useState([]);


    const [userData, setUserData] = useState([]);
    const [data, setData] = useState([]);

    useEffect(() => {
        console.log("Fetching bathroom details...");

        const fetchData = async () => {
            try {
                const res = await fetch(`https://uplbidet-api.vercel.app/api/cr/${sampleId}`);
                if (!res.ok) throw new Error("An error has occurred.");

                const jsonData = await res.json();
                setData(jsonData);
                setMainImage(jsonData.interior_photo);
                setBuildingName(jsonData?.building?.toUpperCase());
                setCollegeName(jsonData?.college?.toUpperCase());
                setBathroomName(jsonData.name);
                setBathroomFloor(jsonData.floor);
                setBathroomAddress(jsonData.description);
                setBathroomRating(jsonData.average_rating);
                setBathroomQualities(jsonData.tags);
                // setDynamicBathroomQualities(jsonData.tags);

                // Fetch logo image after data is fetched
                try {
                    if (jsonData) {
                        setLogoImage(
                            (await import(`../../assets/colleges/${jsonData.college.toUpperCase()}.png`)).default
                        );
                    }
                } catch (error) {
                    console.error("Error fetching logo image: ", error);
                    setLogoImage(FillerImage); 
                }

                // Fetch user data using user.id from the useAuth() hook
                try {
                    const userResponse = await fetch(`https://uplbidet-api.vercel.app/api/users/${user.id}`);
                    if (!userResponse.ok) throw new Error("An error has occurred while fetching user data.");

                    setUserData(await userResponse.json());
                } catch (error) {
                    console.error("Error fetching user data: ", error);
                    setUserData({}); // Handle the error or set a default user data
                }
            } catch (error) {
                console.error("Error fetching data: ", error);
            }
        };

        fetchData();
    }, [sampleId, user.id]);


    console.log(userData)
    console.log(data)

    const [reviews, setReviews] = useState([]);
    useEffect(() => {
        console.log("Fetching reviews...");
        const fetchReviews = async () => {
          try {
            const res = await fetch(`https://uplbidet-api.vercel.app/api/reviews/cr/${sampleId}`);
            if (!res.ok) {
              throw new Error("An error has occured.");
            }
    
            const jsonReviews = await res.json();
            const reviewPromise =  jsonReviews.map(async (review) =>  {
                        const res = await fetch(`https://uplbidet-api.vercel.app/api/users/${review.user_id}`);
                        const user = await res.json();
                        console.log(user._id,user.username,"This is a trial");
                        review.userName = user.username;
                        review.logo = user.user_image;
                    });

            await Promise.all(reviewPromise);
            console.log(jsonReviews,"Add")
            setReviews(jsonReviews);
            setBathroomReviewCount(jsonReviews.length)
          } catch (error) {
            console.error("Error fetching reviews: ", error);
          }
        };
            fetchReviews();
        }, []
    );

    console.log(reviews)

    const getOrdinalNumber = (number) => {
        const suffixes = ["th", "st", "nd", "rd"];
        const v = number % 100;
        return number + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
      };


    const detailsTable = [
        { attribute: 'BIDET', classification: data.bidet},
        { attribute: 'TISSUE PAPER', classification: data.tissue_paper},
        { attribute: 'SOAP', classification: data.soap },
        { attribute: 'HAND DRYER', classification: data.hand_dryer },
        { attribute: 'CLASS', classification: data.type },
      ];

    const fileInputRef = useRef(null);
    const [selectedImage, setSelectedImage] = useState(null);

    const handleAttachButtonClick = () => {
        // Trigger the file selection dialog
        fileInputRef.current.click();
    };
  
    const handleFileChange = async (event) => {
        setSelectedImage(await convertBase64(event.target.files[0]));
    };
  
      // input fields manipulation
      const [StarRating, setStarRating] = useState(0);
      const [inputReview, setInputReview] = useState('');
      const [isButtonDisabled, setButtonDisabled] = useState(true);
      const sendRating = (value) => {
          // This function will be called by ChildComponent to pass the value to MainPage
          setStarRating(value)
      };
  
      useEffect(() => {
          setButtonDisabled(inputReview.trim() === '' && StarRating === 0 && selectedImage === null);
      }, [inputReview, StarRating, selectedImage]);
      
      
    const handlePostButtonClick = async () => {
        const comment = inputReview;
        const cr_id = sampleId; 
        const likes = [];
        const user_id = user.id; 
        const overall_rating = StarRating;
        const status = "All Goods";
        const report_reason = "No Report";
        const time_published = new Date().toString();

        if (comment === '' || selectedImage === null){
            alert(`Please fill a review comment and an image of the comfort room...`)
        } else {
            const bathroomImage = await convertURL(selectedImage)
            const review_photo =  bathroomImage.data

            const newReview = {
                comment,
                cr_id,
                likes,
                user_id,
                overall_rating,
                status,
                report_reason,
                time_published,
                review_photo,
            };
            try {
                const cloudApiUrl = "https://uplbidet-api.vercel.app/api/reviews";
                const res = await Axios.post(cloudApiUrl, newReview);
                console.log("Review posted successfully:", res.status);
                if (res.status === 200) {
                    alert(`This user has an exisiting review for this comfort room...`);
                } else {
                    alert(`
                        Content of the textbox: ${inputReview}
                        Star Rating: ${StarRating}
                        Selected Image: ${review_photo}
                        Review posted successfully!
                    `);
                }
                window.history.back();
                
            } catch (error) {
                alert(`
                    Error in Review Posting...  
                `);
                if (error.response) {
                    console.error("Server responded with an error:", error.response.data);
                } else if (error.request) {
                    console.error("No response received from the server:", error.request);
                } else {
                    console.error("Error setting up the request:", error.message);
                }
                console.error("Full error details:", error);
            }
        }
    };
    
    
    
  
  
    const handleDiscardButtonClick = () => {
        const shouldReturn = window.confirm('Do you want to discard changes and return to the previous window?');

        if (shouldReturn) {
            setStarRating(0)
        // Add logic to handle returning to the previous window
        window.history.back();
        }
    }
    

  return (
    <>
        <Navbar />
        <div className="main-content">
            <div className="workable-area">
                <div className="portion-container">
                    <div className="image-container">
                        <img
                            src={MainImage} 
                            width={300}
                            height={350}
                            padding={10}
                            alt="Image of a bathroom"
                            style={{
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)'
                            }}
                        />

                    </div>

                    <div className="horizontal-flex" >
                        
                        <img 
                            className="logo-style"
                            src={LogoImage}
                            width={75}
                            height={75}
                            alt="This is a logo"
                        />

                        <div className="bathroom-info"> 
                        <span style={{
                            fontFamily: 'Roboto, sans-serif',
                            fontSize: 40,
                        }}>
                            {BuildingName}
                        </span>
                            <span style={{
                                fontFamily: 'Roboto, sans-serif',
                                fontSize: 25,
                            }}>
                                {CollegeName}
                            </span>
                            <span>
                                <i>
                                    {BathroomName}, {getOrdinalNumber(BathroomFloor)} Floor, {BathroomAddress}
                                </i>
                            </span>
                                <span className="new-vertical-flex" style={{marginTop: '5px',}}>
                                    <div className="category-widget">
                                        <div>
                                            RATING:  

                                        </div>
                                        <div style={{color:'gray', paddingLeft:'5px'}}>
                                            <Stars averageRating={BathroomRating} /> 
                                            ({BathroomRating}/5 stars)
                                        </div>
                                    </div>
                                    <div className="category-widget">
                                        <div>
                                            NUMBER OF REVIEWS:

                                        </div>
                                        <div style={{color:'gray', paddingLeft:'25px'}}>
                                            {BathroomReviewCount}
                                        </div>
                                    </div>
                                </span>
                                {BathroomQualities && BathroomQualities.length > 0 && 
                                (
                                    <span className="row-container" style={{marginTop: '5px',}}>
                                        {BathroomQualities.map((item, index) => (
                                            <button className="oval-button">
                                                <div className="text-padding">
                                                    {`${item.tag} (${item.users.length})`}
                                                </div>
                                            </button>
                                        ))}
                                        
                                        {/* <button className="oval-button" onClick={() => handleTagButtonClick(-1)}>
                                            <div className="text-padding">
                                                +
                                            </div>
                                        </button> */}
                                    </span> 
                                )
                                }

                            <span className="horizontal-flex" style={{marginTop: '10px', justifyContent: 'space-between', height: '100%'}}>
                                
                                <div className="new-vertical-flex" style={{justifyContent: 'space-evenly', width: '100%'}}>
                                    <div>DETAILS:</div>
                                    <table style={{ width: '100%' }}>
                                        <tbody>
                                        {detailsTable.map((detailsTable, index) => (
                                            <tr key={index} style={{ justifyContent:'space-between' }}>
                                                <td>{`• ${detailsTable.attribute}:     `}</td>
                                                <td style={{ paddingLeft: '5px', color: 'gray'}}>{
                                                    (detailsTable.classification === true ? 'YES' : 
                                                        (detailsTable.classification == false ? 'NO': 
                                                            (detailsTable.classification === 'pwd'? 'MALE, FEMALE, AND PWD(s)' : 
                                                                detailsTable?.classification?.toUpperCase())))}
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                    </div>
                            </span>
                        </div>
                    </div>
                    <span className="new-vertical-flex" style={{maxHeight: '100vw', justifyContent: "space-between"}}>
                        <MdLocationOn size={90} color="maroon" />
                    </span>
                </div>
                <hr />
                <div className="portion-container">
                    {/* Bottom Portion */}
                    <div className="new-vertical-flex" style={{ width:'100%' }}>
                        <div 
                            style={{
                            fontFamily: 'Roboto, sans-serif',
                            fontSize: 40,
                        }}>
                            Write a review for this restroom
                        </div>

                        <div className='horizontal-flex' style={{ width:'100%', marginTop:'10px'}}>
                            <img 
                                className="logo-style"
                                src={userData.user_image}
                                width={75}
                                height={75}
                                alt="This is a logo"
                            />
                            <span className="new-vertical-flex" style={{flex:'1'}}>
                                <div className="star-rating">
                                    <DynamicStarRating sendRatingToMain={sendRating}/>
                                </div>
                                <textarea
                                    style={{flex: '1'}}
                                    rows="5"
                                    placeholder="Write your reviews here..."
                                    value={inputReview}
                                    onChange={(e) => setInputReview(e.target.value)}
                                />

                            </span>
                            {/* <span className="row-container">
                                <button className="post-button" onClick={handlePostButtonClick}>
                                    <div className="text-padding">
                                    <FaPlus /> POST
                                    </div>
                                </button>

                            </span> */}
                            <div className="new-vertical-flex">
                                <span style={{
                                                // maxWidth: '100%',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                marginBottom: '12px'
                                            }}>
                                    <input
                                        type="file"
                                        multiple
                                        accept="image/*"
                                        ref={fileInputRef}
                                        style={{ display: 'none' }}
                                        onChange={(e) => handleFileChange(e)}
                                    />
                                    {(selectedImage) ? (
                                        <div className="row-container">
                                        <p>Image Attached!</p>
                                        </div>
                                    ) : (
                                        <div className="row-container">
                                        <p>No image attached...</p>
                                        </div>
                                    )
                                    }
                                </span>

                                <span className="row-container">
                                    <button className="rectangular-button" onClick={handleAttachButtonClick}>
                                        <div className="text-padding">
                                            <FaPlus/> ATTACH PHOTO
                                        </div>
                                    </button>
                                </span>

                                <span className="row-container">
                                    <button className="rectangular-red-button" onClick={handleDiscardButtonClick} disabled={isButtonDisabled}>
                                        <div className="text-padding">
                                            DISCARD
                                        </div>
                                    </button>
                                    
                                    <button className="rectangular-red-button" onClick={handlePostButtonClick} disabled={isButtonDisabled}>
                                        <div className="text-padding">
                                            DONE
                                        </div>
                                    </button>

                                </span>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
    );
}

export default AddReview;